var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('section-active-tickets',{staticClass:"section__row"}),_c('section-tickets-in-queue',{staticClass:"section__row"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }